import { createQueryHook } from '@/utils/hooks';
import { getOptionPresetItems, updateOptionPresetItems } from './option-preset-item.api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PresetItemUpdateDto, PresetItemUpdateType } from './option-preset-item.types';
import { Toast } from '@ygtechnologies/bygr-frontend-component-library';
import { t } from '@lingui/core/macro';

export const useOptionPresetItems = createQueryHook(getOptionPresetItems);

export const useOptionPresetItemsUpdate = (presetId: number) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (items: PresetItemUpdateDto[]) => updateOptionPresetItems(presetId, items),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['getOptionPresetItems', presetId] });
        },
    });
};

export const usePresetItemsMutation = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({
            presetId,
            items,
        }: {
            presetId: number;
            items: { optionItemId: number; updateType: PresetItemUpdateType }[];
        }) => updateOptionPresetItems(presetId, items),
        onMutate: async ({ presetId }) => await queryClient.cancelQueries({ queryKey: ['getOptionPresetItems', presetId] }),
        onSuccess: async (_data, variables) => {
            await queryClient.refetchQueries({ queryKey: ['getOptionPresetItems', variables.presetId] });
            await queryClient.invalidateQueries({ queryKey: ['getOptionItemsByGroup'] });
            await queryClient.invalidateQueries({ queryKey: ['getOptionPresetGroupsWithItems'] });
        },
        onError: () => {
            Toast.error(t`Unable to update style products`);
        },
    });
};
